import React, { useState } from "react";
import { Form } from "semantic-ui-react";
import { useFormik } from "formik";
import { Auth } from "../../../../api/auth";
import { useAuth } from "../../../../hooks";
import { initialValues, validationSchema } from "./LoginForm.form";
import "./LoginForm.scss";
const authController = new Auth();

export function LoginForm() {
  const { login } = useAuth();
  const [error, setError] = useState("");

  const formik = useFormik({
    initialValues: initialValues(),
    validationSchema: validationSchema(),
    validateOnChange: false,
    onSubmit: async (formValue) => {
      try {
        setError("");
        const response = await authController.login(formValue);
        authController.setAccessToken(response.access);
        authController.setRefreshToken(response.refresh);
        login(response.access);
      } catch (error) {
        setError(error.msg);
      }
    },
  });

  return (
    <Form onSubmit={formik.handleSubmit}>
      <Form.Input
        name="email"
        label="Correo electrónico"
        icon="mail"
        iconPosition="left"
        onChange={formik.handleChange}
        value={formik.values.email}
        error={formik.errors.email}
      />
      <Form.Input
        name="password"
        type="password"
        label="Contraseña"
        icon="lock"
        iconPosition="left"
        onChange={formik.handleChange}
        value={formik.values.password}
        error={formik.errors.password}
      />
      <Form.Button className="button-login" type="submit" fluid loading={formik.isSubmitting}>
        Entrar
      </Form.Button>
      <p className="register-form__error">{error}</p>
    </Form>
  );
}
